import { PropsWithChildren, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useLogin } from '@users/session/LoginContext';
import FullScreenPreloader from '@dealroadshow/uikit-loader/FullScreenPreloader';
import ErrorCodeHelper from '@dealroadshow/error-codes';
import { getSearchParams } from '../InvestorLoginForm/helpers';

const InvestorAutologin = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const searchParams = getSearchParams(router);
  const { loginInvestorDrs } = useLogin();

  const isAutologin = !!searchParams.email && !!searchParams.entryCode;
  const [showFullScreenPreloader, setShowFullScreenPreloader] = useState(isAutologin);

  useEffect(() => {
    if (isAutologin) {
      loginInvestorDrs(searchParams).catch((e) => {
        if (e?.getCode() === ErrorCodeHelper.getCodeByName('INVESTOR_VERIFICATION_EMAIL_SENT') ||
          e?.getCode() === ErrorCodeHelper.getCodeByName('USER_ACTIVATION_EMAIL_SENT')) {
          const url = new URL(
            `/login/investor/e/${ searchParams.entryCode }/email_verification/${ searchParams.email }`,
            window.location.origin,
          );

          if (searchParams.source) {
            url.searchParams.set('source', searchParams.source);
          }

          router.replace(url.toString());
        } else {
          setShowFullScreenPreloader(false);
        }
      });
    }
  }, []);

  if (isAutologin && showFullScreenPreloader) {
    return (
      <FullScreenPreloader isVisible />
    );
  }

  return children;
};

export default InvestorAutologin;
